import { constants } from "../../constant";

export const metaDataAction = (data) => {
    return {type: constants.IS_META, payload: data};
};
